GameView   = require "views/base/game"
{ DraggyView } = require("views/components/draggy")
SmoothLine = require("lib/draw/smooth-line")
convert    = require("lib/convert")
{ dpi }    = require("lib/device")

class StrikeoutView extends GameView
  template: require("./template")

  events: ->
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super

    { title, words } = data
    title = "" if not title?
    title = convert.toText(title)

    words =
      for { replaces, incorrect } in words when replaces and incorrect
        replaces: convert.toText replaces
        incorrect: convert.toText incorrect

    # replace matching words with placeholders
    # "hello my name" -> "hello my {{1}}"
    for { replaces }, i in words
      title = title.replace replaces, "{{#{i}}}"

    # Because we are splitting white-space, we need to make sure any part of
    # the title that's not part of a supplied word, but is part of a substring
    # is replaced back into the content.
    # eg. "68" in "68%" will make sure the percentage still renders

    # Split title into words: "hello my name" -> ["hello", "my", "name"]
    # for some languages like Chinese, split it per character not per word since it doesn't use spaces.
    data.components =
      for component in title.split(/(\{\{\d+\}\}|[^A-Z])/i) # split (inclusive) by placeholder {{ i }} or non-word characters (whitespace/Chinese)
        if component == ' '
          space: true # will render a space
        else
          index = +component.match(/\{\{(\d+)\}\}/)?[1]
          replaces  =
            if words[index]?.replaces
              component.replace(/\{\{\d+\}\}/, words[index]?.replaces)
            else
              component
          incorrect =
            if words[index]?.incorrect
              component.replace(/\{\{\d+\}\}/, words[index]?.incorrect)
            else
              null
          klass: "delay-#{_.random(3)} scale-#{_.sample(["down", "up"])}"
          incorrect: incorrect
          replaces: replaces
    data

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  show: ->
    super
    canvas = @findOne("canvas")

    @draggy = new DraggyView
      el: canvas
      isParent: true

    @onResize()

    @context = @draggy.el.getContext?("2d") or {}

    @setEl @findAll(".word"), "words"

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop
    @listenTo this, "resize", @onResize

    @context.clearRect?(0, 0, @draggy.el.width, @draggy.el.height)
    el.classList.remove("active", "complete") for el in @getEl("words")

    @enterGame()

    @guesses = []


  onResize: ->
    @draggy.el.width = @el.firstChild.offsetWidth * dpi
    @draggy.el.height = @el.firstChild.offsetHeight * dpi

  onDrag: (draggy, isInitial) ->
    if isInitial
      @line?.animation?.cancel()
      @context.lineCap = "round"
      @context.globalAlpha = 1
      @line = new SmoothLine([], window.getComputedStyle(@el).color, 4 * dpi)

    @addPoint(draggy)

  onDrop: (draggy, isReset) ->
    pts = @line.getPoints()
    selectedWords = []
    { left, top } = @el.firstChild.getBoundingClientRect()

    avgX = pts.reduce(((m, n) -> m + n.x), 0) / pts.length / dpi
    avgY = pts.reduce(((m, n) -> m + n.y), 0) / pts.length / dpi
    minX = pts.reduce(((m, n) -> if m > n.x then n.x else m), Infinity) / dpi
    maxX = pts.reduce(((m, n) -> if m < n.x then n.x else m), 0) / dpi

    for el in @getEl("words") when not el.classList.contains("active")
      bounds = @getBounds el, { x: -left, y: -top }
      buffer = 20

      isWithin =
        ((minX - buffer < bounds.left and maxX + buffer > bounds.right) or
        (avgX > bounds.left and avgX < bounds.right)) and
         avgY > bounds.top  and avgY < bounds.bottom

      el.classList.toggle("active", isWithin)
      selectedWords.push(el) if isWithin

      if isWithin and el.dataset.replaces
        @transform el,
          opacity: 0
          scale: 0.8

    @line.erase @context, =>
      @context.clearRect(0, 0, @draggy.el.width, @draggy.el.height)

    for el in selectedWords
      @guesses.push $(el).text()
      replaces = el.dataset.replaces
      delete el.dataset.replaces
      do (el, replaces) =>
        window.setTimeout (=>
          el.classList.remove("active", "word-incorrect")

          if replaces?
            el.innerHTML = replaces
            @transform el,
              y: 0
              opacity: 1

        ), 600

    @setState("touched")

  addPoint: ({x, y}) ->
    @line.add x: x * dpi, y: y * dpi
    @context.clearRect(0, 0, @draggy.el.width, @draggy.el.height)
    @line.draw(@context)

  isCorrect: ->
    (el for el in @getEl("words") when el.dataset.replaces).length is 0

  answerDetails: ->
    questions    = @options.metadata?.questions or []
    return [] unless questions.length > 0
    details = []

    for q in questions
      correctAnswer = _.find q.answers, (a) -> a.correct == true
      isCorrect = @guesses.includes(q.question.content)
      questionDetails = {
        question: q.question,
        answer: _.find q.answers, (a) -> a.correct == isCorrect
      }
      details.push questionDetails

    details

  endGame: ->
    super

    for el in @getEl("words") when el.dataset.replaces
      el.classList.add "active"
      @transform el, { scale: 0.8, opacity: 0 }

      do (el) =>
        window.setTimeout =>
          replaces = el.dataset.replaces
          delete el.dataset.replaces
          el.innerHTML = replaces
          el.classList.remove("active", "word-incorrect")
          @transform el, { scale: 1, opacity: 1 }
        , 600

    @submit()



module.exports = StrikeoutView
